import React, { useState } from 'react';
import './Footer.css';

const Logo = () => (
  <div className="footer-logo">
    <div className="footer-logo-icon">
      <svg
        viewBox="0 0 88 86"
        className="footer-logo-image"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M87.84 43.52L60.46 81.76C59.97 82.44 59.34 83 58.64 83.32L26.66 38.59L0.42 2C-0.68 0.47 0.42 -1.64 2.29 -1.64H56.37C57.94 -1.64 59.43 -0.89 60.38 0.4L87.76 38.67C88.87 40.23 88.9 41.96 87.84 43.52Z"
          fill="#87C5AD"
        />
        <path
          d="M56.37 83.78H2.29C0.39 83.78 -0.72 81.64 0.4 80.08L17.19 56.56L56.37 83.78Z"
          fill="#619179"
        />
        <path
          d="M58.64 83.32C57.94 83.64 57.14 83.78 56.37 83.78L17.19 56.56L26.52 43.52C27.62 41.99 27.62 39.95 26.66 38.59L58.64 83.32Z"
          fill="#4A715C"
        />
      </svg>
    </div>
    <span>Digital Shifts</span>
  </div>
);

const auditEmailUrl = 'mailto:salma@digitalshifts.studio?subject=Automation%20audit%20assessment%20survey';

export default function Footer() {
  const [email, setEmail] = useState('');

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          {/* Brand column */}
          <div className="footer-brand">
            <Logo />
            <p className="footer-tagline">
              AI automation agency based in Morocco — AI-driven automation that saves time and unlocks efficiency for businesses in Morocco, Africa, Europe, and worldwide.
            </p>
            <div className="newsletter">
              <div className="newsletter-label">Join our newsletter</div>
              <div className="newsletter-form">
                <input
                  type="email"
                  placeholder="your@email.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="newsletter-input"
                />
                <button className="newsletter-btn">Subscribe</button>
              </div>
            </div>
          </div>

          {/* Link columns */}
          <div className="footer-links-grid">
            <div className="footer-col">
              <div className="footer-col-title">Links</div>
              <a href="#services">Services</a>
              <a href="#process">Process</a>
              <a href="#benefits">Benefits</a>
              <a href="#faq">FAQ</a>
            </div>
            <div className="footer-col">
              <div className="footer-col-title">Contact</div>
              <a href={auditEmailUrl}>Request an audit</a>
              <a href="mailto:salma@digitalshifts.studio">salma@digitalshifts.studio</a>
            </div>
            <div className="footer-col">
              <div className="footer-col-title">Socials</div>
              <a href="https://www.instagram.com/digital.shifts/" target="_blank" rel="noreferrer">Instagram</a>
              <a href="https://web.facebook.com/digitalshifts1/" target="_blank" rel="noreferrer">Facebook</a>
              <a href="https://www.linkedin.com/company/digital-shifts/" target="_blank" rel="noreferrer">LinkedIn</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <span>Visioned and Crafted by Digital Shifts</span>
          <span>© {new Date().getFullYear()} All rights reserved</span>
        </div>
      </div>
    </footer>
  );
}
